module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage your IBS Today!"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Manage your IBS, triggers and lifestyle, with an IBS tracker app made by people with IBS for people with IBS."])},
        "soon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soon on iPhone and Android."])},
        "getNotified": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get Notified"])}
      },
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gérez votre SII, Aujourd'hui !"])},
        "subtitle": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gérez votre SII, vos déclencheurs et votre mode de vie grâce à une application de suivi du SII conçue par des personnes souffrant du SII pour des personnes souffrant du SII."])},
        "soon": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Bientôt sur iPhone et Android."])},
        "getNotified": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Soyez Notifiés"])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"en":{"title":"Manage your IBS Today!","subtitle":"Manage your IBS, triggers and lifestyle, with an IBS tracker app made by people with IBS for people with IBS.","soon":"Soon on iPhone and Android.","getNotified":"Get Notified"},"fr":{"title":"Gérez votre SII, Aujourd\u0027hui !","subtitle":"Gérez votre SII, vos déclencheurs et votre mode de vie grâce à une application de suivi du SII conçue par des personnes souffrant du SII pour des personnes souffrant du SII.","soon":"Bientôt sur iPhone et Android.","getNotified":"Soyez Notifiés"}}')
  delete Component.options._Ctor
  
}
